import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';

export const TimeOfDayModuleWrapper = observer(({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'TIME_OF_DAY',
    category: 'Setup Filter',
    type: 'Time of Day',
    domain: 'Time',
  };
  const startHour = softOrder.startHour;
  const startMinute = softOrder.startMinute;
  const endHour = softOrder.endHour;
  const endMinute = softOrder.endMinute;
  return (
    <Component
      details={details}
      startHour={startHour}
      startMinute={startMinute}
      endHour={endHour}
      endMinute={endMinute}
      {...rest}
    />
  );
});

TimeOfDayModuleWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    endHour: PropTypes.number,
    startHour: PropTypes.number,
    startMinute: PropTypes.number,
    endMinute: PropTypes.number
  })
};
